'use client';

import { Button } from '@headlessui/react';
import { useQueryStates, parseAsString } from 'nuqs';
import { ExpandIcon, MinimizeIcon } from '@/icons/solid/12';
import { MODAL_VARIANT_QS } from './Panel';
import { MODAL_BACKDROP_QS } from './Backdrop';
import { MODAL_VARIANTS } from './Modal.variants';

const baseClassName = [
  'size-8',
  'flex',
  'justify-center',
  'items-center',
  'shrink-0',
  'rounded-sm',
  'transition-colors',
  'text-stone-900',
  '[&>svg]:size-3.5',
  'data-hover:bg-stone-100',
  'data-active:bg-stone-200',
  'data-disabled:text-stone-400',
  'data-disabled:border-stone-400',
].join(' ');

const ToggleModalSizeButton = ({
  onChange,
}: {
  onChange?: (
    value: typeof MODAL_VARIANTS.FULLSCREEN | typeof MODAL_VARIANTS.DRAWER,
  ) => void;
}) => {
  const [modalProps, setModalProps] = useQueryStates(
    {
      variant: parseAsString.withDefault(MODAL_VARIANTS.FULLSCREEN),
      withBackdrop: parseAsString.withDefault('visible'),
    },
    {
      urlKeys: {
        variant: MODAL_VARIANT_QS,
        withBackdrop: MODAL_BACKDROP_QS,
      },
    },
  );

  const isCollapsed = modalProps.variant === MODAL_VARIANTS.DRAWER;
  const Icon = isCollapsed ? ExpandIcon : MinimizeIcon;

  return (
    <Button
      data-testid={
        isCollapsed ? 'expand-modal-button' : 'collapse-modal-button'
      }
      className={baseClassName}
      onClick={async () => {
        await setModalProps(
          isCollapsed
            ? { variant: MODAL_VARIANTS.FULLSCREEN, withBackdrop: 'visible' }
            : { variant: MODAL_VARIANTS.DRAWER, withBackdrop: 'hidden' },
        );
        onChange?.(
          isCollapsed ? MODAL_VARIANTS.FULLSCREEN : MODAL_VARIANTS.DRAWER,
        );
      }}
    >
      <Icon className="size-4 stroke-[0.75px]" />
    </Button>
  );
};

export default ToggleModalSizeButton;
